$(document).ready(function () {
  /* Slider for collabs in "our collections" page */
  $('.slider-with-text__slider-container').flickity({
    // options
    cellAlign: 'center',
    contain: true,
    groupCells: '100%'
  });

  /* Slider for our collections page */
  $('.page-slider__container').flickity({
    // options
    groupCells: 1,
    contain: true,
    selectedAttraction: 0.15,
    friction: 0.8
  });

  // When the IP of the user is localized in the US, replace all MyMorel links with USA website link
  $.getJSON('https://ipapi.co/json/', function (data) {
    if (data.country_code == "US") {
      $('a[href*="mymorel.com"]').attr('href', 'https://mymorel-usa.com/');
    }
  });
});

/*
* DROPDOWN JOB OFFERS
*/

$('.job-offer-dropdown__offers-title').click(function () {
  $(this).closest('.job-offer-dropdown__offers-container').find('.job-offer-dropdown__items').slideToggle(400);
  $(this).closest('.job-offer-dropdown__offers-container').find('.job-offer-dropdown__arrow').toggleClass('active');
});

/*
*  REDIRECT PAGE
*/
let $buttons = $('.redirection__tab-title');
let $contents = $('.redirection__dropdown');
$('.redirection__tab-title').click(function () {
  // Remove active classes on the old item 
  $('.redirection__tab-title.active').removeClass('active');
  $('.redirection__dropdown.active').removeClass('active');

  // Get the new item to add active class and display content
  let target = $(this).attr('data-target');
  let matchingContent = $(`.redirection__dropdown#${target}`);
  $(this).addClass('active');
  matchingContent.addClass('active');
});